import { Component, Input } from '@angular/core';
import { InscricaoAluno } from './inscricao-aluno';
import { InscricaoAlunoService } from './inscricao-aluno.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { TipoValidacaoAlunoEnum } from '../util/tipo-validacao-aluno.enum';
import { Router } from '@angular/router';
import { MatSnackBar  } from '@angular/material';
import { PagerComponent } from '../paginator/pager.component';
import { NavegarValidacao } from '../navegar-validacao/navegar-validacao';

@Component({
    templateUrl: './inscricao-aluno-list.component.html',
    selector: 'inscricao-aluno-list',
    styleUrls: [ './inscricao-aluno-list.component.css' ]
})
export class InscricaoAlunoListComponent {

  public filtro : InscricaoAluno = new InscricaoAluno();
    public lista :InscricaoAluno[];
    public listaSituacao: any;
    public columnsToDisplay = ['codigo', 'nome', 'matricula', 'dataInclusao', 'situacao', 'pontuacao', 'acao'];
    public pageSizeOptions = [10, 50, 100];

    @Input() tipo: number;
    @Input() sub : boolean;

    // controla o loading da pagina
    private isLoading: boolean;

    // construtor
    constructor(private inscricaoAlunoService : InscricaoAlunoService,
                private router: Router, public mensagem: MatSnackBar,
                private pagerComponent: PagerComponent) {   }

    // ngOnInit é executado ao entrar na tela
    ngOnInit() {
      this.isLoading= true;
      /*this.inscricaoAlunoService.getPeriodoAtual().subscribe((periodo: Periodo[]) => {
        this.filtro.periodo = periodo[0].perPeriodo + "";
        this.buscar();
        this.comboListaSituacao();
      },
        error =>  this.erro(error)
      );*/
      // TODO: Esse esquema de período atual não está funcionando.
      // O certo é pegar pelo edital vingente. Se tiver mais de um edital vingente, o usuário deve selecionar qual edital vai querer se inscrever
      // Depois tem que criar um novo filtro para pegar pelo edital, nao pelo semestreano
      this.inscricaoAlunoService.recuperaPeriodoAtualInscricao().subscribe(
        (res: InscricaoAluno) => {
          this.filtro.periodo = res.periodo;
          this.buscar();
          this.comboListaSituacao();
          this.isLoading= false;
        },
        error =>  this.erro(error)
      );
    }

    // busca com filtro
    private buscar(): void{
      if(this.filtro.periodo){
         this.inscricaoAlunoService.filtrar(this.filtro).subscribe(
          res=> {
              this.lista = res;
              this.isLoading= false;
          },
          error =>  this.erro(error)
        );
      }else {
        this.mensagem.open("Por favor, digite um período.", 'X', {duration: 5000});
      }
    }


    comboListaSituacao(){
      this.listaSituacao = [
        {id: null, denominacao: "-Selecione-"},
        {id: SituacaoEnum.Inscrito.id, denominacao: SituacaoEnum.Inscrito.descricao},
        {id: SituacaoEnum.IndeferidoTecnico.id, denominacao: SituacaoEnum.IndeferidoTecnico.descricao},
        {id: SituacaoEnum.IndeferidoAcademico.id, denominacao: SituacaoEnum.IndeferidoAcademico.descricao},
        {id: SituacaoEnum.DeferidoTecnico.id, denominacao: SituacaoEnum.DeferidoTecnico.descricao},
        {id: SituacaoEnum.DeferidoAcademico.id, denominacao: SituacaoEnum.DeferidoAcademico.descricao},
        {id: SituacaoEnum.Deferido.id, denominacao: SituacaoEnum.Deferido.descricao},
        {id: SituacaoEnum.PrestacaoContas.id, denominacao: SituacaoEnum.PrestacaoContas.descricao},
        {id: SituacaoEnum.PrestacaoNaoAprovada.id, denominacao: SituacaoEnum.PrestacaoNaoAprovada.descricao},
        {id: SituacaoEnum.Finalizada.id, denominacao: SituacaoEnum.Finalizada.descricao}
      ];
      // se chegar com o tipo, entao veio da tela de validacao
      if(this.tipo){
        this.listaSituacao = [
            {id: SituacaoEnum.Inscrito.id, denominacao: SituacaoEnum.Inscrito.descricao},
            {id: SituacaoEnum.DeferidoTecnico.id, denominacao: SituacaoEnum.DeferidoTecnico.descricao},
            {id: SituacaoEnum.DeferidoAcademico.id, denominacao: SituacaoEnum.DeferidoAcademico.descricao},
            {id: SituacaoEnum.Deferido.id, denominacao: SituacaoEnum.Deferido.descricao}
          ];
      }
    }


    // vai para a tela de validação
    editar(codigo: number){
        this.router.navigate(['/inscricaoaluno', codigo, { sub: true }]);
    }

    validarTecnica(codigo: number){
        if(this.filtro.periodo){
          this.router.navigate(['/validacao', codigo, { tipo: TipoValidacaoAlunoEnum.Tecnico.id, periodo: this.filtro.periodo }]);
        }else {
          this.mensagem.open("Por favor, digite um período.", 'X', {duration: 5000});
        }
    }

    validarAcademico(codigo: number){
      if(this.filtro.periodo){
        this.router.navigate(['/validacao', codigo, { tipo: TipoValidacaoAlunoEnum.Academico.id, periodo: this.filtro.periodo }]);
      }else {
        this.mensagem.open("Por favor, digite um período.", 'X', {duration: 5000});
      }
    }

    validarOrcamento(codigo: number){
      this.router.navigate(['/alunoprestacao', {  sub: true, inscricao: codigo }]);

    }

    proximoRecebido(navegarValidacao:NavegarValidacao){
        if(!navegarValidacao){
          this.mensagem.open("Todas inscrições já foram validadas.", 'X', {duration: 5000});
        }else{
         this.router.navigate(['/validacao', navegarValidacao.idInscricao, { tipo: this.tipo, periodo: this.filtro.periodo, posicao: navegarValidacao.posicao }]);
       }
    }

    desvincular(inscricao: InscricaoAluno){
      inscricao.usuarioAtribuido = undefined;
      this.inscricaoAlunoService.updateSimples(inscricao).subscribe(
        res=> {
          this.mensagem.open("Usuário desvinculado com sucesso.", 'X', {duration: 5000});
        },
        error =>  this.erro(error)
      );
    }

    // mostra erros na tela
   erro(erro: string){
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading= false;
   }

   // finaliza o subscribe
   finaliza(){
     this.isLoading=false;
   }



}
